import type { BufferGeometry } from '@seddi/three';
import { computeVertexNormalsF32, updateVertexAttributeF32 } from '../three/core/bufferGeometry';

/**
 * Update mesh positions.
 * @param geometry - Geometry.
 * @param data - Positions.
 */
export const updatePositions = (
  geometry: BufferGeometry,
  data: Float32Array,
  options?: { computeBoundingSphere?: boolean },
) => {
  // Update vertex attribute for positions
  updateVertexAttributeF32(geometry, 'position', data, 3);
  // Recomute normals
  computeVertexNormalsF32(geometry);

  // Recompute bounding sphere at runtime
  if (options?.computeBoundingSphere) {
    geometry.computeBoundingSphere();
  }
};
